import { render, staticRenderFns } from "./UserPersonalCards.vue?vue&type=template&id=815b5140&"
import script from "./UserPersonalCards.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports